import { render, staticRenderFns } from "./benefits-reward-card.vue?vue&type=template&id=8ac445f4&scoped=true"
import script from "./benefits-reward-card.vue?vue&type=script&lang=js"
export * from "./benefits-reward-card.vue?vue&type=script&lang=js"
import style0 from "./benefits-reward-card.vue?vue&type=style&index=0&id=8ac445f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ac445f4",
  null
  
)

export default component.exports